/**
 * Default carousel section order for the homepage
 * This order is used when the Lab feature flag for carousel reordering is not enabled
 */
export const DEFAULT_CAROUSEL_ORDER: Array<App.LabCarouselSectionOrderPayload['sectionOrder'][number]> = [
  'componentBannerGroup',
  'upsellSection',
  'frontPageUSP',
  'carHireBundledUpcomingOrder',
  'trendingDestinations',
  'maldivesCharterCarousel',
  'offerEndingSoonCarousel',
  'trip',
  'topPicksForMeCarousel',
  'homepageFlightCampaigns',
  'homepageFlightDeals',
  'societeStayUpgradeCarousel',
  'tourOfferCarousel',
  'supportTile',
  'cruiseOfferCarousel',
  'trustIndicatorSection',
  'experienceLuxPlusCarousel',
  'smartExperienceOfferCarousel',
  'marketingCarousel',
  'luxPlusOfferCarousel',
  'hotelOfferCarousel',
  'ultraLuxOfferCarousel',
  'offerEndingSoonCarousel',
  'valuePropositionBanner',
  'blogCarousel',
  'browseOfferTypes',
]
